export default __webpack_public_path__ + "static/media/01 3D (3-4).f96cf159.jpg";